import {loading, stopLoading} from "../../helpers/loading";
import {clearFeedbacksByName} from "../../helpers/forms";
import Axios from "axios";
import {handleAjaxSuccess} from "../../helpers/swalHelper";
import handleAjaxError from "../../helpers/handleAjaxError";

function initManageVoeOrder() {
	const advanceStageButton = document.querySelector('.advance-stage-button');
	if (advanceStageButton) {
		advanceStageButton.addEventListener('click', advanceStage);
	}

	const rejectOrderButton = document.querySelector('.reject-order-button');
	if (rejectOrderButton) {
		rejectOrderButton.addEventListener('click', rejectOrder);
	}


	const addFailedCallButton = document.querySelector('.add-failed-call-button');
	if (addFailedCallButton) {
		addFailedCallButton.addEventListener('click', addFailedCall);
	}

	const performPartialVerificationButton = document.querySelector('.partial-verification-button');
	if (performPartialVerificationButton) {
		performPartialVerificationButton.addEventListener('click', performPartialVerification);
	}

	/**
	 * Methods
	 */

	function advanceStage() {
		loading();

		clearFeedbacksByName(document.body);

		Axios.post(window['routes/client.sandbox.manage-voe-order.advance-stage'])
			.then(handleAjaxSuccess)
			.catch(handleAjaxError)
			.finally(stopLoading);
	}

	function rejectOrder() {
		loading();

		clearFeedbacksByName(document.body);

		Axios.post(window['routes/client.sandbox.manage-voe-order.reject-stage'])
			.then(handleAjaxSuccess)
			.catch(handleAjaxError)
			.finally(stopLoading);
	}

	function addFailedCall() {
		loading();

		clearFeedbacksByName(document.body);

		Axios.post(window['routes/client.sandbox.manage-voe-order.add-failed-call'])
			.then(handleAjaxSuccess)
			.catch(handleAjaxError)
			.finally(stopLoading);
	}

	function performPartialVerification() {
		loading();

		clearFeedbacksByName(document.body);

		Axios.post(window['routes/client.sandbox.manage-voe-order.perform-partial-verification'])
			.then(handleAjaxSuccess)
			.catch(handleAjaxError)
			.finally(stopLoading);
	}
}

export {initManageVoeOrder}
